// App.jsx
import "./App.css";
import StoneGame from "./components/StoneGame";

function App() {
  return (
    <div className="App">
      <main>
        <StoneGame />
      </main>
    </div>
  );
}

export default App;
